import React, { useEffect, useState } from "react";
import { getAllGateways } from "../../../../redux/user/actions";
import { useDispatch, useSelector } from "react-redux";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { Navigate, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DepositImg from "../../../../assets/images/icons/dc.png";
import bankImg from "../../../../assets/images/icons/bank.png";
import { getActiveBankDetails } from "../../../../redux/app/actions";
import BackIcon from "../../../../assets/svg/BackIcon";
import RightArrow from "../../../../assets/images/icons/right-chevron.png";
import { Container } from "react-bootstrap";
import Bitcoin from "../../../../assets/images/icons/pay-partners/bitcoin.png";
import Ethereum from "../../../../assets/images/icons/pay-partners/ethereum.png";
import Tether from "../../../../assets/images/icons/pay-partners/tether.png";
import Binance from "../../../../assets/images/icons/pay-partners/binance.png";
import UsdCoin from "../../../../assets/images/icons/pay-partners/usdcoin.png";
import GtwInfoSection from "../../../components/gateways/GtwInfoSection";

const GatewaysList = () => {
  const dispatch = useDispatch();
  const [gatewaysList, setGatewaysList] = useState([]);
  const { bankDetails } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);
  const isDemoUser =
    process.env.REACT_APP_DEMO_USER_ID &&
    user?.userName === process.env.REACT_APP_DEMO_USER_ID;

  const isAutoGatewayExist = gatewaysList?.deposits?.some(
    (f) => f?.type === "auto"
  );
  const navigate = useNavigate();

  useEffect(() => {
    loadGtwsFromServer();
    dispatch(getActiveBankDetails());
  }, []);

  const handleGatewayClick = (item) => {
    // dispatch(setSelectedGateway(item));
    navigate(`/deposit/${item.id}`);
  };

  const handleBankTransferClick = () => {
    navigate(`/deposit/bank_transfer`);
  };

  const loadGtwsFromServer = async () => {
    const response = await getAllGateways();
    if (response && response?.data?.data?.data) {
      setGatewaysList(response?.data?.data?.data);
    }
  };

  return (
    <>
      {isDemoUser && <Navigate to="/" />}
      <HeaderAfterLogin />

      <main className="main">
        <Container>
          <div className="headingSec">
            <h4 className="depositHeading">Deposit</h4>

            <div className="back-link" onClick={() => navigate(-1)}>
              <BackIcon /> Back
            </div>
          </div>

          <div className="gatewaySection">
            <div className="gatewaypart">
              <Tabs
                defaultActiveKey={isAutoGatewayExist ? "Deposit" : "Deposit"}
                id="uncontrolled-tab-example"
                className=""
              >
                <Tab eventKey="Deposit" title="Payments">
                  {gatewaysList?.deposits
                    ?.sort((a, b) => a?.order - b?.order)
                    .map((item, index) => {
                      return (
                        <div
                          className="cards1"
                          onClick={() => {
                            handleGatewayClick(item);
                          }}
                          key={index}
                        >
                          <div className="card-icon">
                            <img src={DepositImg} />
                          </div>
                          <p style={{ color: "#fff" }}>{item?.name}</p>
                          <img src={RightArrow} alt="arrow" className="arrow" />
                        </div>
                      );
                    })}
                  {bankDetails && (
                    <div
                      className="cards1"
                      onClick={() => {
                        handleBankTransferClick();
                      }}
                    >
                      {" "}
                      <div className="card-icon">
                        <img src={bankImg} />
                      </div>
                      <p style={{ color: "#fff" }}>{"Bank Transfer"}</p>
                      <img src={RightArrow} alt="arrow" className="arrow" />
                    </div>
                  )}
                </Tab>

                {/* <Tab eventKey="bank" title="Bank Transfer">
                  {bankDetails && (
                    <div
                      className="cards1"
                      onClick={() => {
                        handleBankTransferClick();
                      }}
                    >
                      {" "}
                      <div className="card-icon">
                        <img src={bankImg} />
                      </div>
                      <p style={{ color: "#fff" }}>{"Bank Transfer"}</p>
                      <img src={RightArrow} alt="arrow" className="arrow" />
                    </div>
                  )}

                  {gatewaysList?.deposits
                    ?.sort((a, b) => a?.order - b?.order)
                    ?.filter((f) => f?.type === "manual")
                    .map((item, index) => {
                      return (
                        <div
                          className="cards1"
                          onClick={() => {
                            handleGatewayClick(item);
                          }}
                          key={index}
                        >
                          <div className="card-icon">
                            <img src={DepositImg} />
                          </div>
                          <p style={{ color: "#fff" }}>{item?.name}</p>
                          <img src={RightArrow} alt="arrow" className="arrow" />
                        </div>
                      );
                    })}
                </Tab> */}
              </Tabs>
            </div>
          </div>
        </Container>
      </main>
    </>
  );
};
export default GatewaysList;
